/** 紙の中の文字の形（apps/api/src/pdf/quote-html.ts と同じ決まり。ここは DOM も Node も使わない） */

export const esc = (v: unknown): string =>
  String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);
export const nl = (v: string): string => esc(v).replace(/\r?\n/g, "<br>");
/** 金額：3桁区切り。負は △ */
export const yen = (n: number): string => (n < 0 ? "△" + Math.abs(n).toLocaleString("ja-JP") : n.toLocaleString("ja-JP"));
export const qty = (q: number | null): string => (q == null ? "" : Number.isInteger(q) ? String(q) : String(Math.round(q * 100) / 100));
export const pct = (r: number | null): string => (r == null ? "" : `${Math.round(r * 10000) / 100}%`);
export const jdate = (iso: string): string => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[1]}年${Number(m[2])}月${Number(m[3])}日` : iso;
};
export const r1 = (v: number): number => Math.round(v * 10) / 10;
